webpackJsonp([170096724008081],{

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(84);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(119);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(118);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(251);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(250);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _zone = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModuloRicerca = function (_Component) {
	    _inherits(ModuloRicerca, _Component);
	
	    function ModuloRicerca(props) {
	        _classCallCheck(this, ModuloRicerca);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = { value: '', zone: [] };
	        return _this;
	    }
	
	    ModuloRicerca.prototype.componentDidMount = function componentDidMount() {
	        this.setState({ zone: _zone.zone });
	    };
	
	    ModuloRicerca.prototype.handleChange = function handleChange(event) {
	        this.setState({ value: event.target.value });
	    };
	
	    ModuloRicerca.prototype.submitSearch = function submitSearch(event) {
	        event.preventDefault();
	
	        localStorage.setItem('prowed_location', this.state.value);
	
	        (0, _gatsbyLink.navigateTo)('/ricerca-fotografo-o-videografo-professionista/');
	    };
	
	    ModuloRicerca.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: 'uk-section uk-text-center', style: { background: this.props.bak } },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container uk-container-xsmall uk-text-center uk-section uk-padding-remove-top' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'uk-margin-remove uk-h1' },
	                    this.props.titolo
	                )
	            ),
	            _react2.default.createElement(
	                'form',
	                { onSubmit: this.submitSearch.bind(this) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-margin' },
	                    _react2.default.createElement(
	                        'select',
	                        { value: this.state.value, onChange: this.handleChange.bind(this), className: 'uk-select uk-form-width-medium uk-form-large uk-form-width-large uk-margin-small-right' },
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            this.props.placeh
	                        ),
	                        this.state.zone.map(function (zona, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                { key: index, value: zona.value },
	                                zona.testo
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { disabled: this.state.value === '' ? true : false, className: 'uk-button uk-button-danger uk-form-large uk-form-width-small', type: 'submit' },
	                        'Cerca'
	                    )
	                )
	            )
	        );
	    };
	
	    return ModuloRicerca;
	}(_react.Component);
	
	exports.default = ModuloRicerca;
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(133);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _headerpage = __webpack_require__(226);
	
	var _headerpage2 = _interopRequireDefault(_headerpage);
	
	var _footer = __webpack_require__(116);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _moduloricerca = __webpack_require__(249);
	
	var _moduloricerca2 = _interopRequireDefault(_moduloricerca);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cerca = function (_Component) {
	    _inherits(Cerca, _Component);
	
	    function Cerca(props) {
	        _classCallCheck(this, Cerca);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	
	            loading: true
	
	        };
	
	        return _this;
	    }
	
	    Cerca.prototype.componentDidMount = function componentDidMount() {
	        this.setState({ loading: false });
	    };
	
	    Cerca.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            this.state.loading ? _react2.default.createElement(
	                'p',
	                null,
	                'loading'
	            ) : _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(_gatsbyImage2.default, {
	                    sizes: this.props.data.cercaImage.sizes,
	                    style: {
	                        top: 0,
	                        left: 0,
	                        position: 'absolute',
	                        objectFit: 'cover',
	                        height: '100%',
	                        width: '100%',
	                        zIndex: -2
	                    },
	                    imgStyle: {
	                        objectPosition: 'center center'
	                    }
	                }),
	                _react2.default.createElement('div', { className: 'uk-position-cover uk-overlay-primary', style: { zIndex: -1 } }),
	                _react2.default.createElement(_headerpage2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-flex uk-flex-middle uk-flex-center uk-light', 'data-uk-height-viewport': '' },
	                    _react2.default.createElement(_moduloricerca2.default, { titolo: 'Trova il miglior fotografo o videografo professionista', placeh: 'Seleziona la zona', bak: 'transparent' })
	                ),
	                _react2.default.createElement(_footer2.default, { user: { name: 'Prowedding', partitaIva: '12345678901' } })
	            )
	        );
	    };
	
	    return Cerca;
	}(_react.Component);
	
	exports.default = Cerca;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var zone = exports.zone = [{ testo: 'Agrigento (AG)', value: 'Agrigento' }, { testo: 'Alessandria (AL)', value: 'Alessandria' }, { testo: 'Ancona (AN)', value: 'Ancona' }, { testo: 'Aosta (AO)', value: 'Aosta' }, { testo: 'Arezzo (AR)', value: 'Arezzo' }, { testo: 'Ascoli Piceno (Ap)', value: 'Ascoli Piceno' }, { testo: 'Asti (AT)', value: 'Asti' }, { testo: 'Avellino (AV)', value: 'Avellino' }, { testo: 'Bari (BA)', value: 'Bari' }, { testo: 'Barletta-Andria-Trani (BT)', value: 'Barletta' }, { testo: 'Belluno (BL)', value: 'Belluno' }, { testo: 'Benevento (BN)', value: 'Benevento' }, { testo: 'Bergamo (BG)', value: 'Bergamo' }, { testo: 'Biella (BI)', value: 'Biella' }, { testo: 'Bologna (BO)', value: 'Bologna' }, { testo: 'Bolzano (BZ)', value: 'Bolzano' }, { testo: 'Brescia (BS)', value: 'Brescia' }, { testo: 'Brindisi (BR)', value: 'Brindisi' }, { testo: 'Cagliari (CA)', value: 'Cagliari' }, { testo: 'Caltanissetta (CL)', value: 'Caltanissetta' }, { testo: 'Campobasso (CB)', value: 'Campobasso' }, { testo: 'Caserta (CE)', value: 'Caserta' }, { testo: 'Catania (CT)', value: 'Catania' }, { testo: 'Catanzaro (CZ)', value: 'Catanzaro' }, { testo: 'Chieti (CH)', value: 'Chieti' }, { testo: 'Como (CO)', value: 'Como' }, { testo: 'Cosenza (CS)', value: 'Cosenza' }, { testo: 'Cremona (CR)', value: 'Cremona' }, { testo: 'Crotone (KR)', value: 'Crotone' }, { testo: 'Cuneo (CN)', value: 'Cuneo' }, { testo: 'Enna (EN)', value: 'Enna' }, { testo: 'Fermo (FM)', value: 'Fermo' }, { testo: 'Ferrara (FE)', value: 'Ferrara' }, { testo: 'Firenze (FI)', value: 'Firenze' }, { testo: 'Foggia (FG)', value: 'Foggia' }, { testo: 'Forlì-Cesena (FC)', value: 'Forlì' }, { testo: 'Frosinone (FR)', value: 'Frosinone' }, { testo: 'Genova (GE)', value: 'Genova' }, { testo: 'Gorizia (GO)', value: 'Gorizia' }, { testo: 'Grosseto (GR)', value: 'Grosseto' }, { testo: 'Imperia (IM)', value: 'Imperia' }, { testo: 'Isernia (IS)', value: 'Isernia' }, { testo: 'La Spezia (SP)', value: 'La Spezia' }, { testo: 'L\'Aquila (AQ)', value: 'L\'Aquila' }, { testo: 'Latina (LT)', value: 'Latina' }, { testo: 'Lecce (LE)', value: 'Lecce' }, { testo: 'Lecco (LC)', value: 'Lecco' }, { testo: 'Livorno (LI)', value: 'Livorno' }, { testo: 'Lodi (LO)', value: 'Lodi' }, { testo: 'Lucca (LU)', value: 'Lucca' }, { testo: 'Macerata (MC)', value: 'Macerata' }, { testo: 'Mantova (MN)', value: 'Mantova' }, { testo: 'Massa-Carrara (MS)', value: 'Carrara' }, { testo: 'Matera (MT)', value: 'Matera' }, { testo: 'Messina (ME)', value: 'Messina' }, { testo: 'Milano (MI)', value: 'Milano' }, { testo: 'Modena (MO)', value: 'Modena' }, { testo: 'Monza e Brianza (MB)', value: 'Monza' }, { testo: 'Napoli (NA)', value: 'Napoli' }, { testo: 'Novara (NO)', value: 'Novara' }, { testo: 'Nuoro (NU)', value: 'Nuoro' }, { testo: 'Oristano (OR)', value: 'Oristano' }, { testo: 'Padova (PD)', value: 'Padova' }, { testo: 'Palermo (PA)', value: 'Palermo' }, { testo: 'Parma (PR)', value: 'Parma' }, { testo: 'Pavia (PV)', value: 'Pavia' }, { testo: 'Perugia (PG)', value: 'Perugia' }, { testo: 'Pesaro e Urbino (PU)', value: 'Pesaro' }, { testo: 'Pescara (PE)', value: 'Pescara' }, { testo: 'Piacenza (PC)', value: 'Piacenza' }, { testo: 'Pisa (PI)', value: 'Pisa' }, { testo: 'Pistoia (PT)', value: 'Pistoia' }, { testo: 'Pordenone (PN)', value: 'Pordenone' }, { testo: 'Potenza (PZ)', value: 'Potenza' }, { testo: 'Prato (PO)', value: 'Prato' }, { testo: 'Ragusa (RG)', value: 'Ragusa' }, { testo: 'Ravenna (RA)', value: 'Ravenna' }, { testo: 'Reggio Calabria (RC)', value: 'Reggio Calabria' }, { testo: 'Reggio Emilia (RE)', value: 'Reggio Emilia' }, { testo: 'Rieti (RI)', value: 'Rieti' }, { testo: 'Rimini (RN)', value: 'Rimini' }, { testo: 'Roma (RM)', value: 'Roma' }, { testo: 'Rovigo (RO)', value: 'Rovigo' }, { testo: 'Salerno (SA)', value: 'Salerno' }, { testo: 'Sassari (SS)', value: 'Sassari' }, { testo: 'Savona (SV)', value: 'Savona' }, { testo: 'Siena (SI)', value: 'Siena' }, { testo: 'Siracusa (SR)', value: 'Siracusa' }, { testo: 'Sondrio (SO)', value: 'Sondrio' }, { testo: 'Taranto (TA)', value: 'Taranto' }, { testo: 'Teramo (TE)', value: 'Teramo' }, { testo: 'Terni (TN)', value: 'Terni' }, { testo: 'Torino (TO)', value: 'Torino' }, { testo: 'Trapani (TP)', value: 'Trapani' }, { testo: 'Trento (TN)', value: 'Trento' }, { testo: 'Treviso (TV)', value: 'Treviso' }, { testo: 'Trieste (TS)', value: 'Trieste' }, { testo: 'Udine (UD)', value: 'Udine' }, { testo: 'Varese (VA)', value: 'Varese' }, { testo: 'Venezia (VE)', value: 'Venezia' }, { testo: 'Verbania (VB)', value: 'Verbania' }, { testo: 'Vercelli (VC)', value: 'Vercelli' }, { testo: 'Verona (VR)', value: 'Verona' }, { testo: 'Vibo Valentia (VV)', value: 'Vibo Valentia' }, { testo: 'Vicenza (VI)', value: 'Vicenza' }, { testo: 'Viterbo (VT)', value: 'Viterbo' }];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ricerca-js-5e7c0319954d07b84cf6.js